import { TeamsService } from './../../services/teams/team.service';
import { Team } from './../../models/inModels/Team';
import { Component } from '@angular/core';
import { ConfirmationService, LazyLoadEvent, Message, SelectItem } from 'primeng/api';
import { Router } from '@angular/router';
import { DataTable } from "primeng/components/datatable/datatable";

@Component({
  selector: 'app-teams',
  templateUrl: './teams.component.html',
  styleUrls: ['./teams.component.css']
})
export class TeamsComponent{
 	items: Team[];
	rows: SelectItem[];
	selectedRows: number;
	filteredRecords: number;
	rowEvent: LazyLoadEvent;
	loading: boolean;
	totalRecords: number;
	error: Message[];
  constructor(
    private service: TeamsService,
		private router: Router,
    private confirmationService: ConfirmationService) { 
      this.loading = true;
      this.rows = [];
      this.rows.push({ label: '10', value: 10 });
      this.rows.push({ label: '25', value: 25 });
      this.rows.push({ label: '50', value: 50 });
      this.selectedRows = 10;
    }

  
	changeRows(event): void {
		this.loadTeams(this.rowEvent);
	}
	reset(dt: DataTable, gb: HTMLInputElement) {
		gb.value = '';
		dt.reset();
	}

  loadTeams(event: LazyLoadEvent): void {
		this.loading = true;
		event.rows = this.selectedRows;
		this.rowEvent = event;
		this.service.search(event).then(
			dataPager => {
				this.items = dataPager.Data;
				this.filteredRecords = dataPager.FilteredRecords;
				this.totalRecords = dataPager.TotalRecords;
				this.loading = false;
				console.log(this.items);
			},
			error => {
				this.loading = false;
				this.items = [];
				this.totalRecords = 0;
				this.filteredRecords = 0;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}
  
  delete(team: Team) {
		console.log(team);
		this.confirmationService.confirm({
			message: `Are you sure you want to delete ${team.Name}?`,
			header: 'Confirmation',
			icon: 'fa fa-trash-o',
			accept: () => {
				this.loading = true;
				this.service.delete(team.Id).then(
					result => {
						this.loading = false;
						this.loadTeams(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
  }
  
}



// WEBPACK FOOTER //
// ./src/app/components/teams/teams.component.ts